import { defineStore } from 'pinia'
import { removeUserToken } from '~/services/apiClient'
import { resolveLoggedInTeamMember } from '~/cynqueModules/store/resolveLoggedInTeamMember'
import { shouldRefreshLoggedInTeamMember } from '~/cynqueModules/store/shouldRefreshLoggedInTeamMember'

/**
 * Converted from store/loggedInUser.js. Persisted to sessionStorage, not
 * localStorage, so identity and the auth token expire together — see
 * cynqueModules/store/persistedModules.ts.
 *
 * The two pure helpers it delegates to were extracted before the migration
 * precisely so they would carry over untouched; they do.
 */
export const useLoggedInUserStore = defineStore('loggedInUser', {
  state: () => ({
    loggedInUser: undefined as any,
    loggedInTeamMember: undefined as any,
  }),

  getters: {
    getLoggedInUser: (state) => state.loggedInUser,
    getLoggedInTeamMember: (state) => state.loggedInTeamMember,
  },

  actions: {
    async setLoggedInUser(value: any): Promise<void> {
      // eslint-disable-next-line no-console
      console.debug(`[store] Setting loggedInUser to`, value)
      this.loggedInUser = value
      const teamMember = await resolveLoggedInTeamMember(value.id)
      if (teamMember) {
        // eslint-disable-next-line no-console
        console.debug(`[store] Setting loggedInTeamMember to`, teamMember)
        this.loggedInTeamMember = teamMember
      }
    },

    clearLoggedInUser(): void {
      // Clear the auth token alongside the identity so no logout path can
      // orphan a stale token in sessionStorage. logoutUser() also calls
      // removeUserToken(); calling it again here is harmless and idempotent.
      removeUserToken()
      this.loggedInUser = undefined
      this.loggedInTeamMember = undefined
    },

    async refreshLoggedInTeamMember(value: any): Promise<void> {
      const fn = `[stores/loggedInUser.ts] refreshLoggedInTeamMember |`
      const loggedInUserId = this.loggedInUser?.id
      if (
        !shouldRefreshLoggedInTeamMember({
          loggedInUserId,
          loggedInTeamMember: this.loggedInTeamMember,
          requestedTeamMemberId: value,
        })
      ) {
        return
      }
      // eslint-disable-next-line no-console
      console.debug(`${fn} refreshing loggedInTeamMember`)
      try {
        const teamMember = await resolveLoggedInTeamMember(loggedInUserId)
        if (teamMember) {
          this.loggedInTeamMember = teamMember
        }
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(
          `${fn} couldn't get teamMember, so couldn't refresh.` +
            ` This should never happen.`
        )
      }
    },
  },
})
